import { useSelector } from "@jti/store";
export const useSubscription = () => {
    const { isSubscription } = useSelector((state) => state.cart);
    const isSubscriptionOrder = useSelector((state) => state.order.orderDetails.data?.isSubscriptionOrder || false);
    return {
        isSubscription: isSubscription || isSubscriptionOrder,
    };
};
//# sourceMappingURL=useSubscription.js.map